module.exports = __webpack_public_path__ + "static/media/red-carpet.39bf4b8f.svg";